import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import useServices from "../../useHook/useServices";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs";
import ServicesSidebar from "../Sidebar/ServicesSidebar";
import "./ServicesDetails.css";

const ServicesDetails = () => {
  const [data, setData] = useState({});
  const { serviceId } = useParams();
  const [services] = useServices();

  useEffect(() => {
    let newData = {};
    if (services) {
      newData = services.find(
        (data) => parseInt(data.id) === parseInt(serviceId))
    }
    setData(newData);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [serviceId, services]);

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalService",
    "serviceType": data?.title,
    "description": data?.description?.replace(/\\n/g, ' '),
    "provider": {
      "@type": "Dentist",
      "name": "Dr. Alshoutaiui",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Roseggerstraße 23",
        "addressLocality": "Salzburg",
        "postalCode": "5020",
        "addressCountry": "AT"
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>{data?.title ? `${data.title} | Digitale Zahnpraxis Salzburg` : "Zahnbehandlungen Salzburg"}</title>
        <meta name="description" content={data?.description?.replace(/\\n/g, ' ').substring(0, 160) || "Professionelle Zahnbehandlungen in Salzburg mit modernster Technologie"} />
        <link rel="canonical" href={`https://digitalezahnpraxis.at/services/${serviceId}`} />
        <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      </Helmet>

      <Breadcrumbs title={data?.title} />
      <div className="container py-16">
        <article className="grid lg:grid-cols-3 gap-6 lg:justify-items-end">
          <section className="lg:col-span-2" itemScope itemType="https://schema.org/MedicalService">
            <div className="headimgcontainer relative overflow-hidden rounded-xl border-gradient-to-r from-primary to-secondary transition-transform duration-300 hover:scale-105 animate-fadeIn">
              <img
                className="w-full h-auto rounded-xl headimg"
                src={data?.image}
                alt={`${data?.title} Behandlung in Salzburg - Digitale Zahnpraxis Dr. Alshoutaiui`}
                loading="eager"
                width="800"
                height="450"
                itemProp="image"
              />
            </div>
            <h1 className="text-2xl font-Poppins py-4 text-primary animate-fadeIn" itemProp="name">
              {data?.title}
            </h1>
            <div itemProp="description" className="animate-fadeIn">
              <p dangerouslySetInnerHTML={{
                __html: data?.description?.replace(/\\n/g, '<br/>') || ''
              }} />
            </div>
          </section>

          <aside className="lg:mt-0 mt-16">
            <h2 className="text-4xl rounded-t-xl text-center px-4 py-2 font-Poppins bg-secondary text-white">
              Alle Dienstleistungen
            </h2>
            <nav aria-label="Zahnbehandlungsübersicht">
              {services.length > 0 && services.map((service) => (
                <ServicesSidebar key={service.id} service={service} />
              ))}
            </nav>
          </aside>
        </article>
      </div>
    </>
  );
};

export default ServicesDetails;